export default {
  signIn: '登录',
  signOut: '登出',
  points: '积分',
  hyattSignInButton: '登录 World of Hyatt',
};
